import Head from 'next/head';
import { APP_META_KEYWORDS, APP_NAME } from './meta.config';
import PageMeta from './PageMeta.model';

type IProps = {
  page_meta: PageMeta | null | undefined;
  useExactTitle?: boolean;
};

const PageMetaHead = ({ page_meta, useExactTitle }: IProps) => {
  if (!page_meta) return null;

  let title = page_meta.title ? `${APP_NAME} - ${page_meta.title}` : APP_NAME;
  if (useExactTitle) {
    title = page_meta.title ? page_meta.title : APP_NAME;
  }

  return (
    <Head>
      {page_meta.keywords && <meta name='keywords' content={APP_META_KEYWORDS} />}

      <title>{title}</title>
      <meta key='og:title' property='og:title' content={title} />
      <meta key='og:site_name' property='og:site_name' content={title} />
      <meta key='twitter:title' name='twitter:title' content={title} />

      {page_meta.description && (
        <>
          <meta key='description' name='description' content={page_meta.description} />
          <meta key='og:description' property='og:description' content={page_meta.description} />
          <meta key='twitter:description' name='twitter:description' content={page_meta.description} />
        </>
      )}

      {page_meta.thumbnail && (
        <>
          <meta key='og:image' property='og:image' content={page_meta.thumbnail} />
          <meta key='og:image:secure_url' property='og:image:secure_url' content={page_meta.thumbnail} />
          <meta key='twitter:image' name='twitter:image' content={page_meta.thumbnail} />
        </>
      )}
    </Head>
  );
};

export default PageMetaHead;
